import { Link } from "react-router-dom";
import { categories, articles } from "@/mocks/articles";
import { siteInfo } from "@/mocks/site";
import SEOHead from "@/components/feature/SEOHead";
import SchemaOrg from "@/components/feature/SchemaOrg";
import { StructuredData } from "@/mocks/schema";

const articleImages: Record<string, string> = {
  "article-intro-01":
    "https://readdy.ai/api/search-image?query=Clean%20modern%20minimalist%20workspace%20with%20laptop%20on%20wooden%20desk%2C%20natural%20light%2C%20professional%20atmosphere%2C%20editorial%20photography%2C%20warm%20cream%20tones%2C%20calm%20and%20focused%20mood%2C%20soft%20shadows&width=800&height=450&seq=article-intro-01&orientation=landscape",
  "article-install-02":
    "https://readdy.ai/api/search-image?query=Smartphone%20with%20app%20installation%20screen%2C%20clean%20minimal%20setup%2C%20warm%20lighting%2C%20modern%20flat%20lay%2C%20tech%20lifestyle%2C%20professional%20photography%2C%20soft%20cream%20background&width=800&height=450&seq=article-install-02&orientation=landscape",
  "article-fake-03":
    "https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20digital%20screen%2C%20cybersecurity%20concept%2C%20minimalist%20design%2C%20warm%20professional%20atmosphere%2C%20abstract%20tech%20patterns%2C%20clean%20editorial%20style&width=800&height=450&seq=article-fake-03&orientation=landscape",
  "article-security-04":
    "https://readdy.ai/api/search-image?query=Digital%20security%20shield%20concept%2C%20padlock%20on%20abstract%20background%2C%20warm%20golden%20tones%2C%20minimalist%20tech%20aesthetic%2C%20professional%20data%20protection%20theme%2C%20clean%20modern%20design&width=800&height=450&seq=article-security-04&orientation=landscape",
  "article-faq-05":
    "https://readdy.ai/api/search-image?query=FAQ%20help%20center%20concept%2C%20organized%20documents%20and%20icons%2C%20warm%20professional%20atmosphere%2C%20clean%20minimalist%20workspace%2C%20editorial%20style%2C%20soft%20natural%20light&width=800&height=450&seq=article-faq-05&orientation=landscape",
  "article-compare-06":
    "https://readdy.ai/api/search-image?query=Comparison%20split%20screen%20concept%2C%20two%20smartphones%20side%20by%20side%2C%20minimalist%20tech%20comparison%2C%20warm%20neutral%20tones%2C%20clean%20professional%20photography%2C%20soft%20lighting&width=800&height=450&seq=article-compare-06&orientation=landscape",
};

export default function Home() {
  const latestArticles = articles.slice(0, 6);

  return (
    <>
      <SEOHead
        title="首页"
        description={siteInfo.description}
        keywords="91直播平台, 直播平台资讯, 91直播使用说明, 91直播安全提示, 版本辨别"
      />
      <SchemaOrg data={StructuredData.website} />

      {/* Hero Section */}
      <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20abstract%20geometric%20composition%20with%20warm%20amber%20and%20cream%20tones%2C%20soft%20gradients%2C%20smooth%20curved%20shapes%2C%20clean%20and%20professional%20atmosphere%2C%20tech-inspired%20subtle%20patterns%2C%20elegant%20and%20sophisticated%20digital%20art%20background&width=1800&height=1240&seq=hero-bg-main&orientation=landscape"
          alt="91直播平台资讯站"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
        <div className="relative z-10 w-full px-4 md:px-6 text-center">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 tracking-tight">
              {siteInfo.name}
            </h1>
            <p className="text-base md:text-lg text-white/85 mb-8 leading-relaxed max-w-xl mx-auto">
              {siteInfo.description}
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/zixun"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-compass-line"></i>
                浏览资讯
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 text-white border border-white/30 rounded-md text-sm font-medium hover:bg-white/25 transition-colors whitespace-nowrap"
              >
                <i className="ri-information-line"></i>
                了解我们
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Category Cards */}
      <section className="w-full py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                内容分类
              </h2>
              <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
                按主题浏览，快速找到您需要的信息
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group bg-background-50 border border-background-200/70 rounded-lg p-6 hover:border-primary-300 transition-all duration-200"
                >
                  <div className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-100/80 mb-4 group-hover:bg-accent-200 transition-colors">
                    <i className={`${cat.icon} text-lg text-accent-700`}></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-500 transition-colors">
                    {cat.name}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {cat.description}
                  </p>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Latest Articles */}
      <section className="w-full py-14 md:py-20 bg-background-100">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-6xl mx-auto">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 gap-4">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
                  最新文章
                </h2>
                <p className="text-sm text-foreground-600">
                  持续更新的91直播平台相关资讯与指南
                </p>
              </div>
              <Link
                to="/category/zixun"
                className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
              >
                查看全部
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {latestArticles.map((article) => {
                const cat = categories.find((c) => c.slug === article.category);
                const imgSrc = articleImages[article.imageSeq] || articleImages["article-intro-01"];
                return (
                  <Link
                    key={article.slug}
                    to={`/article/${article.slug}`}
                    className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-200 flex flex-col"
                  >
                    <div className="relative w-full h-44 overflow-hidden">
                      <img
                        src={imgSrc}
                        alt={article.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                    </div>
                    <div className="p-4 md:p-5 flex flex-col flex-1">
                      <div className="flex items-center gap-3 mb-3">
                        {cat && (
                          <span className="text-xs px-2 py-0.5 bg-accent-100 text-accent-700 rounded-full whitespace-nowrap">
                            {cat.name}
                          </span>
                        )}
                        <span className="text-xs text-foreground-500 whitespace-nowrap">
                          {article.date}
                        </span>
                      </div>
                      <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors leading-snug">
                        {article.title}
                      </h3>
                      <p className="text-xs md:text-sm text-foreground-600 line-clamp-2 leading-relaxed flex-1">
                        {article.excerpt}
                      </p>
                      <div className="mt-3 text-xs text-foreground-500 flex items-center gap-1">
                        <i className="ri-time-line"></i>
                        {article.readTime}
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="w-full py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              需要更多帮助？
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mb-8 max-w-lg mx-auto leading-relaxed">
              查看我们的常见问题页面，或通过关于我们页面了解联系方式。访问或下载前请确认来源可靠，并遵守当地法律法规。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/wenti"
                className="inline-flex items-center gap-2 px-6 py-3 bg-secondary-500 text-background-50 rounded-md text-sm font-medium hover:bg-secondary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-question-answer-line"></i>
                常见问题
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 text-foreground-700 rounded-md text-sm font-medium hover:bg-background-100 transition-colors whitespace-nowrap"
              >
                <i className="ri-mail-line"></i>
                联系我们
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}